import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import _notification from 'modules/notification';
import { Card, Table, Modal, Tag, Icon } from 'antd';
import ConfirmPopup from '../popup/ConfirmPopup';
import MyInput from 'components/controls/MyInput';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import FileUpload from '../../components/controls/FileUpload';
import ButtonComponent from 'components/controls/Button';
import xls from '../../assets/template/BankTxnFileTemplate.xlsx';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';

class UploadBankTransactions_new extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            uploadedDoc: "",
            fileError: "",
            loading: false,
        };
    }

    componentDidMount() {

    }

    handleUpload = async (input) => {
        if(this.state.uploadedDoc && this.state.fileError == ""){
            try {
                this.setState({ loading: true }, async () => {
                    try {
                        var formData = new FormData()
                        formData.append('file', this.state.uploadedDoc)

                        //console.log("Form data: ", formData);

                        const response = await _AdminService.UploadBankTransactions(formData);
                        //console.log("Upload File response: ", response);
                        if (response.status == 200) {
                            _notification.showMessage('success', "File uploaded successfully.");
                            this.setState({
                                uploadedDoc: "",
                                fileError: "",
                                loading: false,
                            });
                        }
                        else {
                            _notification.showMessage('error', response.data.message);
                        }
                    } catch (e) {
                        // TODO
                        this.setState({ loading: false });
                        console.log('Error: ', e);
                        _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                    }
                });
            } catch (e) { }
        }else{
            _notification.showMessage('error', "Select file to upload");
        }
    }

    onFileDrop = (file) => {
        //console.log(file);
        this.setState({ uploadedDoc: file, fileError: '' });
    }

    onFileError = (errorMsg) => {
        console.log(errorMsg);
        this.setState({ fileError: errorMsg })
    }


    render() {

        if (this.state.loading)
            return <LoadingSpinner/>

        return (

                <div className="container-fluid p-3">
                    <PageHeader
                        title="Upload Bank Transactions"
                        breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Transactions' }, { label: 'Upload Bank Transactions' }]}
                    />
                    <div style={{ textAlign: 'right' }}>          
                            <div className="max1200 m-auto mb-2"> 
                                <div className="d-flex align-items-center justify-content-end">
                                    <a className="button-global button-border addbutton autoWidth d-inline-block text-center autoHeight mb-3 d-flex align-items-center justify-content-center" 
                                    href={xls} ><Icon type="download" className="mr-2 font1rem" /> Download Template</a>

                                </div>
                            </div>  
                    </div>
                    <div className="max1200 m-auto">
                        <div className="ent-panel">
                            <h4 className="heading4">Upload Bank Transactions file </h4>
                            <div className="admin-inner-wrap p-3">  
                                
                                <div className="mb-2 col-sm-12 uploadCard">
                                    <FileUpload onFileDrop={this.onFileDrop} onError={this.onFileError} />
                                    {this.state.fileError ? <label className="textAlignCenter  "><span className="color-red">Error: {this.state.fileError}</span></label> : <></>}
                                </div>
                            </div>
                            <div className="pt-4 buttonAlignCenter" >
                                <ButtonComponent type="button" value="Upload File" onClick={this.handleUpload} className="button-global button-primary autoHeight small" disabled={this.state.loading} />
                            </div>
                        </div>
                    </div>
                </div>

        )
    };
}

export default UploadBankTransactions_new;